import React, { useEffect, useState } from 'react';
import "../components/styles/SearchPage.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaRegFrown } from "react-icons/fa";

const SearchPage = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setSearchTerm('');  // 페이지 로드 시 입력 창 초기화
    }, []);

    useEffect(() => {
        const getProductList = async () => {
            try {
                const response = await fetch("/api/items", {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                });

                const data = await response.json();
                if (response.ok) {
                    const sortedProducts = [...data.items].sort((a, b) => b.rating - a.rating);  // 인기순 정렬
                    setProducts(sortedProducts);
                    setLoading(false);
                } else {
                    const errorData = await response.json();
                    setError(errorData.message || "상품 데이터 불러오기에 실패했습니다.");
                    setLoading(false);
                }
            } catch (err) {
                setError("상품 데이터를 불러오는 중 오류가 발생했습니다.");
                setLoading(false);
                console.error(err);
            }
        };
        getProductList();
    }, []);

    useEffect(() => {
        const fetchSuggestions = async () => {
            if (searchTerm.trim() === '') {
                setSuggestions([]);
                return;
            }

            try {
                const response = await axios.get(`/api/search/suggestions?q=${searchTerm}`);
                setSuggestions(response.data);
            } catch (error) {
                console.error('Error fetching suggestions:', error);
            }
        };

        const delayDebounceFn = setTimeout(() => {
            fetchSuggestions();
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [searchTerm]);

    const handleInputChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const getProductDetail = (itemId) => {
        navigate(`/products/${itemId}`);
    };

    return (
        <div className="search-page">
            <input
                type="text"
                placeholder="검색어를 입력해주세요"
                value={searchTerm}
                onChange={handleInputChange}
                className={`search-input ${searchTerm ? 'active' : ''}`}
            />
            {searchTerm && suggestions.length > 0 && (
                <div className="suggestions">
                    {suggestions.map((item, index) => (
                        <div key={item.itemId || index} className="suggestion-item" role={'button'} onClick={() => getProductDetail(item.itemId)}>
                            {item.itemName}
                        </div>
                    ))}
                </div>
            )}

            <div className="related-products-search">
                <h2>인기 상품</h2>
                {products.length === 0 ? (
                    <div className="no-product-container">
                        <div className="no-product-image">
                            <FaRegFrown size={100} color="#6C95FF" />
                        </div>
                        <div className="no-product-content">
                            <p className="no-product-description">현재 판매중인 상품이 없습니다.</p>
                        </div>
                    </div>
                ) : (
                    <div className="product-grid">
                        {products.slice(0, 4).map((product, index) => (
                            <div key={index} className="product-card relative" role="button" onClick={() => getProductDetail(product.itemId)}>
                                {product.category === 'DISCOUNTED' && (
                                    <div className="discount-badge absolute top-3 left-3 bg-red-500 text-white px-3 py-1 rounded-full shadow-md text-sm font-semibold z-10 animate-pulse">
                                        할인상품
                                    </div>
                                )}
                                <div className="product-image">
                                    {product.thumbFileName && product.thumbPath ? (
                                        <img src={product.thumbPath || "/placeholder.svg"} alt={product.itemName} className="w-full h-full object-cover rounded-xl" />
                                    ) : (
                                        <div className="w-full h-full bg-gray-200 flex items-center justify-center rounded-xl">
                                            <span className="text-gray-400">No Image</span>
                                        </div>
                                    )}
                                </div>
                                <h2 className="product-title mt-2 font-semibold text-lg">{product.itemName}</h2>
                                <p className="product-description text-gray-600 text-sm">{product.itemDescription}</p>
                                <p id="product-original-price" className="line-through text-gray-400">{product.costPrice}원</p>
                                <div className="product-price-grid-main flex items-center justify-between mt-1">
                                    <p className="product-discount-rate text-red-500 font-bold">{product.discountRate}%</p>
                                    <p className="product-price text-xl font-bold text-gray-800">{product.salePrice}원</p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SearchPage;
